<template>
  <div>
    <van-nav-bar :title="t('reembolso.title')" :border="false" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="flex items-center px-[13px]">

      <div class="date-select mt-[27px] mr-[10px]">
        <Border radius="4px" borderWidth="1px">
          <div class="date-btn misen" :class="{ 'active': showOptions }" @click="toggleOptions(1)">
            {{ dateOptions[selectedDate].label }}
            <span :class="['arrow', showOptions ? 'up' : 'down']"></span>
          </div>

        </Border>
      </div>


      <div class="date-select mt-[27px]">
        <Border radius="4px" borderWidth="1px">
          <div class="date-btn misen2" :class="{ 'active': showOptions2 }" @click="toggleOptions(2)">
            {{ selectedDate2.name || t('reembolso.selectVendor') }}
            <span :class="['arrow', showOptions2 ? 'up' : 'down']"></span>
          </div>
        </Border>
      </div>
      <div class="flex-1 flex justify-end items-center mt-[27px]">
        <div class="text-[12px] text-white">{{ t('reembolso.bet') }}</div>
        <div class="text-[12px] text-white ml-[30px] text-center">
          <div>{{ t('reembolso.refundRate') }}</div>
        </div>
      </div>
    </div>

    <!-- 第一个下拉选项 -->
    <div v-show="showOptions" class="date-options-full">
      <button v-for="(item, idx) in dateOptions" :key="item.value"
        :class="['option-btn', { active: idx === selectedDate }]" @click="selectDate(idx)">
        {{ item.label }}
      </button>
    </div>

    <!-- 第二个下拉选项 -->
    <div v-show="showOptions2" class="date-options-full">
      <button v-for="(item, idx) in dateOptions2" :key="item.id || idx"
        :class="['option-btn', { active: item.id === selectedDate2.id }]" @click="selectDate2(item)">
        {{ item.name }}
      </button>
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <div v-for="(item, index) in tableData" :key="index" class="table-row">
        <div class="table-cell">{{ getGameTypeLabel(item.gameType) }}</div>
        <div class="table-cell">{{ item.vendorName }}</div>
        <div class="table-cell" style="padding-left: 50px;">{{ numberFormat(item.position) }}</div>
        <div class="table-cell  ">{{ numberFormat(item.ratio * 100, { minDecimals: 2 }) }}%</div>
      </div>
    </div>
  </div>
  <div class="empty-data" v-if="tableData.length === 0">
    <div class="flex justify-center items-center">
      <img :src="getAssetsFile('home/No_record@2x.png')" alt="" class="max-h-[84px] max-w-[106.5px] w-auto h-auto">
    </div>
    <div class="empty-text">{{ t('reembolso.noRecords') }}</div>
  </div>
</template>
<script setup lang="ts">
import { Border } from "@/components/Border"
import { Button } from "@/components/Button"
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n'
import { numberFormat } from '@/utils/formatter';
import { getAssetsFile } from '@/utils/pub-use';
const { t } = useI18n()
const now = new Date()
import * as GameApi from '@/api/game';

// 定义类型接口
interface VendorItem {
  id: number;
  name: string;
}

interface TableDataItem {
  gameType: string;
  vendorName: string;
  position: number;
  ratio: number;
}

// 使用计算属性来动态生成 dateOptions，支持多语言
const dateOptions = computed(() => [
  { label: t('reembolso.cards'), value: 'CHESS' },
  { label: t('reembolso.slot'), value: 'SLOTS' },
  { label: t('reembolso.fishing'), value: 'FISH' },
  { label: 'Live', value: 'LIVE' },
  { label: t('reembolso.hall'), value: 'HALL' },
  { label: t('reembolso.videoGame'), value: 'VIDEO_GAME' },
  { label: t('reembolso.arcades'), value: 'ARCADES' },
])
// 将 dateOptions2 改为响应式数组
const dateOptions2 = ref<VendorItem[]>([])
const router = useRouter()
const route = useRoute()
const selectedDate = ref(0)
const selectedDate2 = ref<VendorItem>({} as VendorItem) // 改为对象，用于存储选中的厂商信息
const showOptions = ref(false)
const showOptions2 = ref(false)
const onClickLeft = () => {
  // 返回到 activity 页面的 rebate 标签页
  router.push('/activity?tab=rebate');
}
function toggleOptions(type: number) {
  if (type === 1) {
    showOptions.value = !showOptions.value
    showOptions2.value = false // 隐藏第二个
  } else {
    showOptions2.value = !showOptions2.value
    showOptions.value = false // 隐藏第一个
  }
}

function selectDate(idx: number) {
  selectedDate.value = idx
  showOptions.value = false

  // 获取选中的游戏类型
  const selectedGameType = dateOptions.value[idx].value

  // 更新参数
  const newParams = {
    gameType: selectedGameType,
    vendorId: vendorId.value
  }

  // 如果已经选择了厂商，则调用接口
  if (selectedDate2.value && selectedDate2.value.id) {
    const tableParams = {
      gameType: selectedGameType,
      vendorId: selectedDate2.value.id
    }

    GameApi.getVendorAntiWater(tableParams).then((tableRes) => {
      tableData.value = (tableRes.data || []).reverse()
    }).catch((error) => {
      console.error('获取表格数据失败:', error)
    })
  } else {
    // 如果没有选择厂商，清空表格数据
    tableData.value = []
  }
}

function selectDate2(item: VendorItem) {
  selectedDate2.value = item
  showOptions2.value = false

  // 当选择厂商时，重新调用API获取数据
  const newParams = {
    gameType: dateOptions.value[selectedDate.value].value, // 修复：使用 dateOptions.value
    vendorId: item.id
  }

  GameApi.getVendorAntiWater(newParams).then((res) => {
    tableData.value = (res.data || []).reverse()
  }).catch((error) => {
    console.error('获取表格数据失败:', error)
  })
}
const formatAmount = (val: number) => {
  if (val == null) return '0,00';
  return numberFormat(val, { minDecimals: 2 });
};
// 添加游戏类型转换函数，支持多语言
const getGameTypeLabel = (gameTypeValue: string) => {
  const gameTypeMap = {
    'CHESS': t('reembolso.cards'),
    'SLOTS': t('reembolso.slot'),
    'FISH': t('reembolso.fishing'),
    'LIVE': 'Live',
    'HALL': t('reembolso.hall'),
    'VIDEO_GAME': t('reembolso.videoGame'),
    'ARCADES': t('reembolso.arcades')
  }
  return gameTypeMap[gameTypeValue] || gameTypeValue
}
// 表格数据
const tableData = ref<TableDataItem[]>([])
const vendorId = ref('')
const gameType = ref('')
const params = ref({
  gameType: '',
  vendorId: ''
})

onMounted(() => {
  vendorId.value = route.query?.vendorId as string || ''
  gameType.value = route.query?.gameType as string || ''

  // 根据路由传过来的gameType设置默认选中的游戏类型
  if (gameType.value) {
    const gameTypeIndex = dateOptions.value.findIndex(item => item.value === gameType.value)
    if (gameTypeIndex !== -1) {
      selectedDate.value = gameTypeIndex
    }
  }

  // 更新params对象
  params.value = {
    gameType: gameType.value || dateOptions.value[0].value, // 如果没有传gameType，使用第一个选项
    vendorId: vendorId.value
  }

  // 先获取厂商列表
  const vendorParams = {
    gameType: '',
  }
  GameApi.thirdPartygetGameVendors(vendorParams).then((res) => {
    dateOptions2.value = res.data || []

    // 根据路由传过来的vendorId设置默认选中的厂商
    if (vendorId.value && dateOptions2.value.length > 0) {
      // 确保类型一致，将vendorId转换为数字进行比较
      const targetVendorId = Number(vendorId.value)
      const vendorIndex = dateOptions2.value.findIndex(item => Number(item.id) === targetVendorId)

      if (vendorIndex !== -1) {
        selectedDate2.value = dateOptions2.value[vendorIndex]
      } else {
        // 如果没找到对应的厂商，选择第一个
        selectedDate2.value = dateOptions2.value[0]
      }
    } else if (dateOptions2.value.length > 0) {
      // 如果没有传vendorId，选择第一个厂商
      selectedDate2.value = dateOptions2.value[0]
    }
  }).catch((error) => {
  })

  console.log('vendorId:', vendorId.value)
  console.log('gameType:', gameType.value)
  console.log('params:', params.value)

  // 获取表格数据
  GameApi.getVendorAntiWater(params.value).then((res) => {
    tableData.value = (res.data || []).reverse() // 倒序显示
  }).catch((error) => {
  })
})
</script>
<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.date-select {
  position: relative;
}

.date-btn {
  background: transparent;

  color: #fff;

  padding: 4px 5px 4px 12px;
  font-size: 11px;
  font-weight: 500;
  outline: none;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.2s ease;
}

.misen {
  min-width: 50px;
}

.misen2 {
  min-width: 100px;
}

/* @media (max-width: 768px) {
    .misen{
      min-width: 80px;
    }
    .misen2{
      min-width: 100px;
    }
  } */
.date-btn.active {
  border-color: #ffffff;
}

.arrow {
  display: inline-block;
  margin-left: 16px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #60B289 !important;
  /* 添加!important确保优先级 */
  transition: transform 0.2s;
}

/* 确保即使父元素active时，箭头颜色也不变 */
.date-btn.active .arrow {
  border-top-color: #60B289 !important;
}

.arrow.up {
  transform: rotate(180deg);
}

.arrow.down {
  transform: rotate(0deg);
}

.date-options-full {
  background: #02523d;
  border-radius: 3px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  display: flex;
  z-index: 10;
  padding: 5px 10px 10px;
  gap: 4px;
  margin: 10px 13px 0;
  flex-wrap: wrap;
  /* 允许换行 */
}

.option-btn {
  background: #00563A;
  border: 1px solid #5DC09B;
  color: #5DC09B;
  border-radius: 5px;
  padding: 8px 4px;
  /* 减少内边距 */
  font-size: 10px;
  /* 减小字体大小 */
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  text-align: center;
  white-space: normal;
  /* 允许文本换行 */
  word-wrap: break-word;
  /* 允许长单词换行 */
  word-break: break-word;
  /* 在合适的地方换行 */
  width: calc(25% - 3px);
  flex-shrink: 0;
  min-height: 40px;
  /* 设置最小高度确保按钮有足够空间 */
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  /* 调整行高 */
}

.option-btn.active {
  background: linear-gradient(0deg, #1D9554 0%, #13C96A 100%);
  color: #fff;
  font-weight: bold;
  border: 1px solid #40b665;
}

.table-container {
  margin: 13px 13px;
  background: #02523d;
  overflow: hidden;
}

.table-row {
  display: flex;
  color: white;
  font-size: 10px;
  padding: 0 10px 0 25px;
  /* 左内边距增加到35px，右内边距保持25px */
}

.table-row:nth-child(odd) {
  background: #00563A;
}

.table-row:nth-child(even) {
  background: #004D37;
}

.table-cell {
  flex: 1;
  padding: 13px 8px;
  text-align: center;
  white-space: nowrap;
}

.table-cell:first-child {
  text-align: left;
}

.table-cell:last-child {
  text-align: right;
}

.table-cell.aposta {
  margin-left: 0px;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 115px;
}

.empty-text {
  color: #ADB1B0;
  font-size: 11px;
  margin-top: 21px;
}
</style>
<route lang="json5">
  {
    name: 'reembolso',
    meta: {
      title: 'Taxa de reembolso',
      i18n: 'menus.reembolso'
    }
  }
  </route>
